export default function extractErrorMessage(error: any) {
    return error?.response?.data[0]?.message;
}